"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _navPanel = _interopRequireDefault(require("./nav-panel"));
var _primaryHamburgerNavPanel = _interopRequireDefault(require("./primary-hamburger-nav-panel"));
var _secondaryHamburgerNavPanel = _interopRequireDefault(require("./secondary-hamburger-nav-panel.js"));
var _mask = _interopRequireDefault(require("../../mask"));
var _preventFocus = _interopRequireDefault(require("../../prevent-focus"));
require("./hamburger-nav.css");
var _excluded = ["subNavItems", "signOutButton"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HamburgerNav = function HamburgerNav(_ref) {
  var accountButton = _ref.accountButton,
    accountNav = _ref.accountNav,
    auxiliaryContent = _ref.auxiliaryContent,
    closeHamburgerNav = _ref.closeHamburgerNav,
    findAStorePin = _ref.findAStorePin,
    hamburgerNavFooter = _ref.hamburgerNavFooter,
    isHamburgerNavOpen = _ref.isHamburgerNavOpen,
    isUserAuthenticated = _ref.isUserAuthenticated,
    joinNowButton = _ref.joinNowButton,
    _ref$navItems = _ref.navItems,
    navItems = _ref$navItems === void 0 ? [] : _ref$navItems,
    pushViewButtonLabels = _ref.pushViewButtonLabels,
    signInButton = _ref.signInButton,
    signOutButton = _ref.signOutButton;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    secondaryPanelToOpen = _useState2[0],
    setSecondaryPanelToOpen = _useState2[1];
  // 'returnFocusElement' will be used to set focus on the last clicked push view button
  // when user goes back to the primary nav panel.
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    returnFocusElement = _useState4[0],
    setReturnFocusElement = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!isHamburgerNavOpen) {
      setSecondaryPanelToOpen(null);
    }
  }, [isHamburgerNavOpen]);
  var createSecondaryNavPanel = function createSecondaryNavPanel(parentItem, key) {
    var subNavItems = parentItem.subNavItems,
      signOutProps = parentItem.signOutButton,
      pushViewItemProps = _objectWithoutProperties(parentItem, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_navPanel["default"], {
      isHamburgerNavOpen: isHamburgerNavOpen,
      isNavPanelOpen: secondaryPanelToOpen === parentItem.children,
      isSecondaryNavPanel: true,
      key: key,
      returnFocusElement: returnFocusElement,
      secondaryNavPanelName: parentItem.children
    }, /*#__PURE__*/_react["default"].createElement(_secondaryHamburgerNavPanel["default"], {
      closeHamburgerNav: closeHamburgerNav,
      navItems: subNavItems,
      pushViewButtonLabels: pushViewButtonLabels,
      pushViewItem: pushViewItemProps,
      setSecondaryPanelToOpen: setSecondaryPanelToOpen,
      signOutButton: signOutProps
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_mask["default"], {
    className: "sb-hamburgerNav__mask",
    isActive: isHamburgerNavOpen,
    onClick: closeHamburgerNav
  }), /*#__PURE__*/_react["default"].createElement(_preventFocus["default"], {
    enabled: Boolean(secondaryPanelToOpen)
  }, /*#__PURE__*/_react["default"].createElement(_navPanel["default"], {
    hasNavFooter: Boolean(hamburgerNavFooter),
    isHamburgerNavOpen: isHamburgerNavOpen,
    isNavPanelOpen: isHamburgerNavOpen
  }, /*#__PURE__*/_react["default"].createElement(_primaryHamburgerNavPanel["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    auxiliaryContent: auxiliaryContent,
    closeHamburgerNav: closeHamburgerNav,
    findAStorePin: findAStorePin,
    hamburgerNavFooter: hamburgerNavFooter,
    isUserAuthenticated: isUserAuthenticated,
    joinNowButton: joinNowButton,
    navItems: navItems,
    pushViewButtonLabels: pushViewButtonLabels,
    setReturnFocusElement: setReturnFocusElement,
    setSecondaryPanelToOpen: setSecondaryPanelToOpen,
    signInButton: signInButton,
    signOutButton: signOutButton
  }))), navItems.map(function (item, i) {
    var hasSubNavItems = item.subNavItems && item.subNavItems.length;
    if (hasSubNavItems) {
      return createSecondaryNavPanel(item, i);
    }
  }), accountNav && createSecondaryNavPanel(_objectSpread(_objectSpread({}, accountNav), {}, {
    signOutButton: signOutButton
  })));
};
var _default = exports["default"] = HamburgerNav;